// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3YMo4","dragIcon":"SortableItem_dragIcon__33aF1","disabled":"SortableItem_disabled__1CKyp"};